/**
 * Android-only `PortfolioFilePickerHost` 全局注册表。
 *
 * `pickPortfolioFilesOnAndroid` 通过 wait/get 调用 Host.pick；
 * `openPortfolioScreenshotModal` 在取消或重试前调用 `resetPortfolioFilePickerHostState`
 * 以 abort 卡住的 session 并清除 `pickInFlight`。
 *
 * iOS/Web 不注册 Host（`setPortfolioFilePickerHost(null)`）。
 */
import type { PortfolioUploadType } from "@components/PortfolioScreenshotModal/types";

export type PortfolioFilePickerHostApi = {
  pick: (uploadType: PortfolioUploadType) => Promise<File[] | null>;
  resetPickState: () => void;
};

let hostApi: PortfolioFilePickerHostApi | null = null;

export function setPortfolioFilePickerHost(
  api: PortfolioFilePickerHostApi | null,
): void {
  hostApi = api;
}

export function getPortfolioFilePickerHost(): PortfolioFilePickerHostApi | null {
  return hostApi;
}

export function resetPortfolioFilePickerHostState(): void {
  hostApi?.resetPickState();
}

const HOST_READY_RETRY_MS = 50;
const HOST_READY_MAX_WAIT_MS = 3000;

/** Wait until {@link PortfolioFilePickerHost} registers (mounted in root layout). */
export function waitForPortfolioFilePickerHost(): Promise<void> {
  if (hostApi) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const startedAt = Date.now();
    const tick = () => {
      if (hostApi || Date.now() - startedAt >= HOST_READY_MAX_WAIT_MS) {
        resolve();
        return;
      }
      window.setTimeout(tick, HOST_READY_RETRY_MS);
    };
    tick();
  });
}
